import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import {
  ThemeProvider,
  coreTheme,
} from "@andorhealth/clientuireact.designsystem";
import "@andorhealth/clientuireact.designsystem/style.css";

export function AppThemeProvider({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider theme={coreTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
